import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { SFXVersion } from '../../../utils/sfx/versioning'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

const sfxRetailerConfigR09: DomainAccessControlConfig = {
  minSfxVersion: SFXVersion.r2023_09_0,
  warehouseFeatureToggles: FeatureToggle.storefront,
}

const sfRetailerConfig: DomainAccessControlConfig = {
  minSfxVersion: SFXVersion.r2023_11_0,
}

const unataRetailerConfig: DomainAccessControlConfig = {
  warehouseFeatureToggles: FeatureToggle.unataRetailersOnIPP,
}

// We need to version gate this tool for SFX retailers on R09 and allow it for a set
// list of Unata retailers. We also allow it for SF and SFP retailers on R11.
// By returning an array of `DomainAccessControlConfig`s the permission system will OR them, allowing
// access if any of the configs passes.
function buildAccessControl(permissions: Permission[]): DomainAccessControlConfig {
  return [
    {
      permissions,
      ...sfxRetailerConfigR09,
    },
    {
      permissions,
      ...sfRetailerConfig,
    },
    {
      permissions,
      ...unataRetailerConfig,
    },
  ]
}

export const autosuggestViewAccessControl: DomainAccessControlConfig = buildAccessControl([
  Permission.AutosuggestView,
])

export const autosuggestModifyAccessControl: DomainAccessControlConfig = buildAccessControl([
  Permission.AutosuggestModify,
])
